module.exports = __webpack_public_path__ + "img/logo.85e1acb3.png";